export const PRESCRIPTION_TYPE_OPTIONS = [
  { value: 'simple', label: 'Simples' },
  { value: 'special_control', label: 'Controle Especial' },
] as const;

const LEGACY_SPECIAL_TYPES = new Set([
  'special_control',
  'controlled_blue',
  'controlled_yellow',
  'special_white',
  'antimicrobial',
  'dental',
]);

/** Normaliza tipos legados para o formulário (simple | special_control). */
export function normalizePrescriptionType(type?: string): string {
  if (!type || type === 'simple') return 'simple';
  if (LEGACY_SPECIAL_TYPES.has(type)) return 'special_control';
  return 'special_control';
}

export const prescriptionTypeLabels: Record<string, string> = {
  simple: 'Simples',
  special_control: 'Controle Especial',
  controlled_blue: 'Controle Especial',
  controlled_yellow: 'Controle Especial',
  special_white: 'Controle Especial',
  antimicrobial: 'Controle Especial',
  dental: 'Controle Especial',
};

export const prescriptionTypeColors: Record<string, string> = {
  simple: '#3b82f6',
  special_control: '#3b82f6',
  controlled_blue: '#3b82f6',
  controlled_yellow: '#3b82f6',
  special_white: '#3b82f6',
  antimicrobial: '#3b82f6',
  dental: '#3b82f6',
};

export function prescriptionTypeLabel(type?: string): string {
  return prescriptionTypeLabels[type || ''] || 'Receituário';
}

export const SPECIAL_PRESCRIPTION_DB_TYPES = [
  'special_control',
  'controlled_blue',
  'controlled_yellow',
  'special_white',
  'antimicrobial',
  'dental',
];

const SPECIAL_TYPE_SET = new Set<string>(SPECIAL_PRESCRIPTION_DB_TYPES);

export function itemsRequireSpecialPrescription(
  items?: Array<{ is_controlled?: boolean; is_antimicrobial?: boolean }> | null,
): boolean {
  return Boolean(items?.some((item) => item?.is_controlled || item?.is_antimicrobial));
}

/** Tipo efetivo para impressão e persistência — considera itens controlados/antimicrobianos. */
export function resolveEffectivePrescriptionType(
  prescriptionType?: string | null,
  items?: Array<{ is_controlled?: boolean; is_antimicrobial?: boolean }> | null,
): string {
  const itemList = Array.isArray(items) ? items : [];
  if (itemList.length > 0) {
    if (!itemsRequireSpecialPrescription(itemList)) return 'simple';
    if (itemList.some((i) => i?.is_antimicrobial) && !itemList.some((i) => i?.is_controlled)) {
      return 'antimicrobial';
    }
    const stored = String(prescriptionType || 'simple').toLowerCase();
    if (stored !== 'simple' && SPECIAL_TYPE_SET.has(stored)) return stored;
    return 'special_control';
  }

  const stored = String(prescriptionType || 'simple').toLowerCase();
  if (stored !== 'simple' && SPECIAL_TYPE_SET.has(stored)) return stored;
  return 'simple';
}
